import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: '/home'
  },

  {
    path: '/Login',
    component: resolve => require(['../components/page/Login.vue'], resolve),
  },
  {
    path: '/',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    meta: {
      title: '自述文件'
    },
    children: [{
      path: '/home',
      component: resolve => require(['../components/page/index.vue'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/innovation_academic',
      component: resolve => require(['../components/page/innovation_academic.vue'], resolve),
      meta: {
        title: '教育教学创新'
      }
    },
    {
        path: '/download',
        component: resolve => require(['../components/page/download.vue'], resolve),
        meta: {
          title: '客户端下载',
          requireAuth: true,
        }
    },
    {
      path: '/Article',
      component: resolve => require(['../components/page/Article.vue'], resolve),
      meta: {
        title: '学校概况',
        requireAuth: true,
      }
    },
    {
      path: '/VideoList',
      component: resolve => require(['../components/page/VideoList.vue'], resolve),
      meta: {
        title: '学校视窗',
        requireAuth: true,
      },
    },
    {
      path: '/school_article_excellent',
      component: resolve => require(['../components/page/SchoolArticleExcellent.vue'], resolve),
      meta: {
        title: '精品文章',
        requireAuth: true,
      },
    },
    {
      path: '/school_video_excellent',
      component: resolve => require(['../components/page/SchoolVideoExcellent.vue'], resolve),
      meta: {
        title: '精品视频',
        requireAuth: true,
      },
    },
    {
      path: '/school_space_master',
      component: resolve => require(['../components/page/SchoolSpaceMaster.vue'], resolve),
      meta: {
        title: '精品视频',
        requireAuth: true,
      },
    },
    {
      path: '/ArticleList',
      component: resolve => require(['../components/page/ArticleList.vue'], resolve),
      meta: {
        title: '新闻中心',
        requireAuth: true,
      },
    },
    {
      path: '/school_video_weike',
      component: resolve => require(['../components/page/school_video_weike.vue'], resolve),
      meta: {
        title: '班级微课',
        requireAuth: true,
      },
    },
    {
      path: '/school_video_class',
      component: resolve => require(['../components/page/school_video_class.vue'], resolve),
      meta: {
        title: '课堂实录',
        requireAuth: true,
      },
    },
    {
      path: '/school_article_theory',
      component: resolve => require(['../components/page/school_article_theory.vue'], resolve),
      meta: {
        title: '理论研究',
        requireAuth: true,
      },
    },
    {
      path: '/school_article_teaching',
      component: resolve => require(['../components/page/school_article_teaching.vue'], resolve),
      meta: {
        title: '教学资源',
        requireAuth: true,
      },
    },
    {
      path: '/school_newedu',
      component: resolve => require(['../components/page/school_newedu.vue'], resolve),
      meta: {
        title: '新教育',
        requireAuth: true,
      },
    },

    {
      path: '/school_activity_group',
      component: resolve => require(['../components/page/school_activity_group.vue'], resolve),
      meta: {
        title: '专题工作',
        requireAuth: true,
      },
    },

    {
      path: '/school_activity_discussion',
      component: resolve => require(['../components/page/school_activity_discussion.vue'], resolve),
      meta: {
        title: '专题讨论',
        requireAuth: true,
      },
    },
    // {
    //   path: '/school_space_student',
    //   component: resolve => require(['../components/page/school_space_student.vue'], resolve),
    //   meta: {
    //     title: '亲子空间',
    //     requireAuth: true,
    //   },
    // },
    // {
    //   path: '/school_space_teacher',
    //   component: resolve => require(['../components/page/school_space_teacher.vue'], resolve),
    //   meta: {
    //     title: '教师空间',
    //     requireAuth: true,
    //   },
    // },
    // {
    //   path: '/school_activity_record',
    //   component: resolve => require(['../components/page/school_activity_record.vue'], resolve),
    //   meta: {
    //     title: '专题讨论',
    //     requireAuth: true,
    //   },
    // },
    {
      path: '/school_webcast_class',
      component: resolve => require(['../components/page/school_webcast_class.vue'], resolve),
      meta: {
        title: '直播课堂',
        requireAuth: true,
      },
    },
    {
      path: '/school_webcast_tv',
      component: resolve => require(['../components/page/school_webcast_tv.vue'], resolve),
      meta: {
        title: '校园电视台',
        requireAuth: true,
      },
    },
    {
      path: '/school_webcast_meeting',
      component: resolve => require(['../components/page/school_webcast_meeting.vue'], resolve),
      meta: {
        title: '会议直播',
        requireAuth: true,
      },
    },


    {
      path: '/school_activity_presentation',
      component: resolve => require(['../components/page/school_activity_sszp.vue'], resolve),
      meta: {
        title: '师生展评',
        requireAuth: true,
      },
    },
    {
      path: '/school_activity_preparation',
      component: resolve => require(['../components/page/school_activity_preparation.vue'], resolve),
      meta: {
        title: '集体备课',
        requireAuth: true,
      },
    },
    {
      path: '/school_space_class',
      component: resolve => require(['../components/page/school_space_class.vue'], resolve),
      meta: {
        title: '班级空间',
        requireAuth: true,
      },
    },
    {
      path: '/school_space_tch_stu',
      component: resolve => require(['../components/page/school_space_tch_stu.vue'], resolve),
      meta: {
        title: '师生空间',
        requireAuth: true,
      },
    },
    {
      path: '/TeacherStatistics',
      component: resolve => require(['../components/page/TeacherStatistics.vue'], resolve),
      meta: {
        title: '教师数据',
        requireAuth: true,
      },
    },
    {
      path: '/SchoolStatistics',
      component: resolve => require(['../components/page/SchoolStatistics.vue'], resolve),
      meta: {
        title: '学校数据',
        requireAuth: true,
      },
    },
    {
      path: '/school_activity_zhaning',
      component: resolve => require(['../components/page/school_activity_sszp.vue'], resolve),
      meta: {
        title: '师生展评new',
        requireAuth: true,
      },
    },
    {
      path: '/error',
      component: resolve => require(['../components/page/404.vue'], resolve),
      meta: {
        title: '404'
      }
    },
    ],
  },
  {
        path: '*',
        component: () => import('@/common/404.vue'),
    },
  ]
})